import {couponsActionTypes} from "../constants/ActionTypes";

const initialState = {
  coupon: [],
  effectTypes: [],
  conditions: {},
  isRequestPending: false
};

const coupons = (state = initialState, action) => {

  switch (action.type) {
    case couponsActionTypes.GET_COUPON:
      return {
        ...state,
        coupon: action.coupon,
      };
    case couponsActionTypes.GET_COUPON_OPTIONS:
      return {
        ...state,
        effectTypes: action.effectTypes,
        conditions: action.conditions
      };
    case couponsActionTypes.IS_REQUEST_PENDING:
      return {
        ...state,
        isRequestPending: action.state
      };
  }

  return state;
};

export default coupons;


// WEBPACK FOOTER //
// ./reducers/coupons.reducers.js